import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getVisits } from '../services/authService';
import { showSuccess, showError } from '../utils/alert';
import Loader from '../components/Loader'; // Adjust path
import { useSelector } from 'react-redux';
const HomeVisits = () => {
  const navigate = useNavigate();
  const [visits, setVisits] = useState([]);
  const [filteredVisits, setFilteredVisits] = useState([]);
  const [search, setSearch] = useState('');
  const [visitType, setVisitType] = useState('all');
  const [healthStatus, setHealthStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true); // Moved useState here
  const perPage = 10;
 const selectedVillageId = useSelector((state) => state.village.selectedVillageId);
  const fetchVisits = async (page = 1) => {
    try {
      setLoading(true); // Set loading to true before fetching

      const result = await getVisits(page, perPage);  
       
      console.log('Fetched visits response:', result); 
  
      // Ensure visits is always an array
      setVisits(Array.isArray(result.data?.data) ? result.data.data : []);
      setCurrentPage(result.data?.meta?.current_page || 1);
      setTotalPages(result.data?.meta?.last_page || 1);
    } catch (err) {
      console.error('Failed to fetch', err);
      setVisits([]); // Fallback to empty on error
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };

  useEffect(() => {
    fetchVisits(currentPage);
  }, [currentPage,selectedVillageId]);

  useEffect(() => {
    let filtered = [...visits];
  
    if (search.trim()) {
      filtered = filtered.filter((v) =>
        (v.beneficiary_name ?? '').toLowerCase().includes(search.toLowerCase())
      );
    }
  
    if (visitType !== 'all') {
      filtered = filtered.filter(
        (v) => (v.visit_purpose ?? '').toLowerCase() === visitType.toLowerCase()
      );
    }
  
    if (healthStatus !== 'all') {
      filtered = filtered.filter(
        (v) => (v.health_status ?? '').toLowerCase() === healthStatus.toLowerCase()
      );
    }
  
    setFilteredVisits(filtered);
  }, [search, visitType, healthStatus, visits, selectedVillageId]);
    

  const handleClick = () => {
    navigate('/home-add');
  };

  const parseActions = (raw) => {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    } catch (e) {
      return [];
    }
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    return today.getFullYear() - birthDate.getFullYear();
  };

  const getAvatarIcon = (category) => {
    if (category === 'Child') return 'child_care';
    if (category === 'Elderly') return 'elderly';
    return 'pregnant_woman';
  };

  if (loading) return <Loader />;

  return (
    <>
      {/* Page Header */}
      <div className="page-header">
    
        <div className="page-title">Home Visits</div>
        <button className="add-button" onClick={handleClick}>
          <span className="material-icons icon">add</span>
          New Home Visit
        </button>
      </div>

      {/* Filter Bar */}
      <div className="filter-bar">
        <div className="search-field">
          <span className="material-icons search-icon">search</span>
          <input
            type="text"
            className="search-input"
            placeholder="Search by beneficiary name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <select
          className="filter-dropdown"
          value={visitType}
          onChange={(e) => setVisitType(e.target.value)}
        >
          <option value="all">All Visit Types</option>
          <option value="Routine">Routine</option>
          <option value="Follow-up">Follow-up</option>
          <option value="Emergency">Emergency</option>
        </select>

        <select
          className="filter-dropdown"
          value={healthStatus}
          onChange={(e) => setHealthStatus(e.target.value)}
        >
          <option value="all">All Statuses</option>
          <option value="healthy">Healthy</option>
          <option value="minor">Minor Issues</option>
          <option value="attention">Requires Attention</option>
          <option value="critical">Critical</option>
        </select>

        <div className="date-filter">
          <span className="material-icons icon">date_range</span>
          Last 30 days
        </div>

        <button className="filter-button">
          <span className="material-icons icon">filter_list</span>
          Filters
        </button>
      </div>

      {/* Visit List */}
      <div className="visit-list">
        {filteredVisits.map((visit, index) => {
          const actions = parseActions(visit.actions_taken);
          const visitDate = new Date(visit.visit_datetime).toLocaleString();
          const age = calculateAge(visit.beneficiary_age);

          return (
            <div className="visit-card" key={index}>
              <div className="visit-card-header">
                <div className="visit-date">{visitDate}</div>
                <div
  className={`visit-tag ${(visit.visit_purpose ?? '')
    .toLowerCase()
    .replace(/\s/g, '-')}-tag`}
>
  {visit.visit_purpose ?? 'N/A'}
</div>

              </div>

              <div className="visit-card-content">
                <div className="beneficiary-row">
                <div
  className={`beneficiary-avatar ${(visit.beneficiary_category ?? '')
    .toLowerCase()
    .replace(/\s/g, '-')}-avatar`}
>
  <span className="material-icons">
    {getAvatarIcon(visit.beneficiary_category ?? '')}
  </span>
</div>

                  <div className="beneficiary-info">
                    <div className="beneficiary-name">
                      {visit.beneficiary_name}
                    </div>
                    <div className="beneficiary-details">
                      {age} years • {visit.beneficiary_gender} •{' '}
                      {visit.beneficiary_category}
                    </div>
                  </div>
                </div>

                <div className="visit-details-row">
                  <span className="material-icons visit-details-icon">
                    location_on
                  </span>
                  <div>{visit.village_name}</div>
                </div>

                <div className="visit-details-row">
                  <span className="material-icons visit-details-icon">
                    assignment
                  </span>
                  <div>{actions.join(', ')}</div>
                </div>
                <div
  className={`status-chip status-${(visit.health_status ?? '')
    .toLowerCase()
    .replace(/\s/g, '-')}`}
>
  {visit.health_status ?? 'N/A'}
</div>

              </div>

              <div className="visit-card-actions">
                <span className="material-icons action-icon">edit</span>
                <span className="material-icons action-icon">delete</span>
                <span className="material-icons action-icon">more_vert</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Pagination */}
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(1)}
          disabled={currentPage === 1}
        >
          <span className="material-icons">first_page</span>
        </button>
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          <span className="material-icons">chevron_left</span>
        </button>

        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={`pagination-button ${
              currentPage === i + 1 ? 'active' : ''
            }`}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        >
          <span className="material-icons">chevron_right</span>
        </button>
        <button
          onClick={() => setCurrentPage(totalPages)}
          disabled={currentPage === totalPages}
        >
          <span className="material-icons">last_page</span>
        </button>

        <div className="pagination-text">
          Page {currentPage} of {totalPages}
        </div>
      </div>
    </>
  );
};

export default HomeVisits;  